<div *ngIf="(componentData$ | async)?.content" [innerHTML]="(componentData$ | async)?.content"></div>